import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Space, message } from 'antd';
import { userApi } from '../api/user';
import { DoctorProfile, UpdateDoctorProfileRequest } from '../api/user';

const Profile: React.FC = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [userProfile, setUserProfile] = useState<DoctorProfile | null>(null);

  // 获取用户资料
  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const response = await userApi.getDoctorProfile();
        if (response.success && response.data) {
          setUserProfile(response.data);
          form.setFieldsValue({
            name: response.data.name,
            title: response.data.title
          });
        } else {
          message.error('获取个人资料失败');
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
        message.error('网络错误，无法获取个人资料');
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [form]);

  // 提交更新
  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const updateData: UpdateDoctorProfileRequest = {
        name: values.name,
        title: values.title
      };

      const response = await userApi.updateDoctorProfile(updateData);
      if (response.success) {
        message.success('个人资料更新成功');
        setUserProfile(response.data);
      } else {
        message.error(response.message || '更新失败，请稍后重试');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      message.error('网络错误，更新失败');
    } finally {
      setLoading(false);
    }
  };

  if (loading && !userProfile) {
    return <div>加载中...</div>;
  }

  return (
    <div>
      <h2>个人资料</h2>
      <Card style={{ marginTop: 16 }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="name"
            label="姓名"
            rules={[{ required: true, message: '请输入姓名!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="title"
            label="职称"
            rules={[{ required: true, message: '请输入职称!' }]}
          >
            <Input placeholder="例如：主任医师、主治医师" />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                保存修改
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Profile;